import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import "./css/servicios.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";
import "./css/mantenimientos.css"
import TablaMantenimientos from "./TablaMantenimientos";

function InfoMantenimiento() {
    return (
        <Fragment>
            <Container fluid={true} className="banner-servicios d-none d-md-block">
                <Row >
                    <Col md={12} className="px-0">
                        <Helmet>
                            <link rel="preload" href={BannerDatos} as="image" />
                        </Helmet>
                        <Card>
                            <img
                                src={BannerDatos}
                                alt="Hyundai Banner"
                                className="d-none d-sm-block"
                                width="100%"
                                height="350"
                            />
                            <Card.Img
                                src={BannerDatosmobile}
                                alt="Hyundai Banner"
                                className="d-block d-sm-none"
                                width="300" 
                                height="200"
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-servicios w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="servicios-banner-titulo">Mantenimiento.</h1>
                                        <br />
                                        <h2 className="servicios-banner-subtitulo">
                                            Para garantizar tu inversión y el óptimo funcionamiento de
                                            tu Hyundai
                                            <br />
                                            utiliza solo repuestos genuinos y mano de obra calificada.
                                        </h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="mb-5 pb-3 mt-4 mantenimiento mantenimiento-group d-none d-md-block">
                <Row>
                    <Col xs={6} className="px-0">
                        <Button variant="secondary" className="btn-active" block>
                            Mantenimiento
                        </Button>
                    </Col>
                    <Col xs={6} className="px-0">
                        <Link
                            to="/manual-del-propietario"
                            className="text-reset text-decoration-none"
                        >
                            <Button variant="secondary" block>
                                Manual del propietario
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
            <Container width="100%" height="700px">
                <Row className="pt-3">
                    <Col md={12}>
                        <Alert variant="secondary p-3 p-md-4 ">
                            <p className="manenimiento-texto text-center mb-0">
                                A continuación encontrarás el listado de
                                precios correspondiente a los diferentes mantenimientos de tu vehículo.
                            </p>
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TablaMantenimientos />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
export default InfoMantenimiento;